import { Button, ButtonGroup, ButtonGroupProps } from '@chakra-ui/react'
import { Thread_Type_Enum } from '@gql'
import React from 'react'
import { useTranslation } from 'react-i18next'

interface Props extends Omit<ButtonGroupProps, 'value' | 'onChange'> {
  value: Thread_Type_Enum | undefined
  onChange(value: Thread_Type_Enum): void
}

export default function ThreadTypeButtons({
  value,
  onChange,
  ...buttonGroupProps
}: Props) {
  const { t } = useTranslation()

  const handleSelectTactical = () => onChange(Thread_Type_Enum.Tactical)
  const handleSelectGovernance = () => onChange(Thread_Type_Enum.Governance)

  return (
    <ButtonGroup isAttached variant="outline" {...buttonGroupProps}>
      <Button
        colorScheme="teal"
        variant={value === Thread_Type_Enum.Tactical ? 'solid' : 'outline'}
        onClick={handleSelectTactical}
      >
        {t('ThreadType.Tactical')}
      </Button>
      <Button
        colorScheme="purple"
        variant={value === Thread_Type_Enum.Governance ? 'solid' : 'outline'}
        onClick={handleSelectGovernance}
      >
        {t('ThreadType.Governance')}
      </Button>
    </ButtonGroup>
  )
}
